module.exports = __webpack_public_path__ + "img/zoom-icon.b6fd3cf6.png";